class ProductPack extends HTMLElement {
  constructor() {
    //debugger;
    super();



    this.tripackdiscount = 0;
    this.sixpackdiscount = 0;
    // window.addEventListener("message", (event) => {
    //   if (event.data === "ig-ready") {
    //     this.evaluateIntelligence();
    //     this.updateIntelligencePrices();
    //   }
    // });
     
   
    this.variants_IDs = [];
    this.totalItems = 0;
    this.unitOriginalPrice = window.predictProduct.price ? window.predictProduct.price: 0;
    this.sidecart = document.querySelector("side-cart");
    this.atcBtn = document.querySelector(".multiple-add-to-cart");
    this.packSizes = document.querySelectorAll(".pack-size__wrapper input");
    this.available = true;


  }

  changeIcon(fit) {
    fit = fit.replace('boxer ','');
    let icons = document.getElementById('tees-icons');
    let iconsCurrent = [...icons.querySelectorAll(`option[fit="${fit}"]`)];

    iconsCurrent.forEach((iconCurrent) => {
      const icon = iconCurrent.value;
      const pack = iconCurrent.getAttribute('pack');
      const label = document.querySelector(`label.pack-size[for="${pack}"]`);
      //label.style.backgroundImage = `url(${icon})`;
      if (label) label.querySelector('img').src = icon;
    });

    // every iconCurrent is a option that has as value the icon image who must to be displayed at the label.pack-size where the fit is selected and the attr of the label [for] must be equal to the option  attribute [pack]






  }
  evaluateIntelligence() {
      const firstVariant = document.getElementById("first_variant").value;

      const packsContainer = document.querySelector('.pack-size__wrapper');
      const packLabels = {
          2: packsContainer.querySelector('label[for="pack-2"] .savings'),
          3: packsContainer.querySelector('label[for="pack-3"] .savings'),
          6: packsContainer.querySelector('label[for="pack-6"] .savings')
      };

      const regex = /\d+(?:\.\d+)?/;
      Object.entries(packLabels).forEach(([packSize, label]) => {
          if (label) {
              const match = label.innerHTML.match(regex);
              this[`pack${packSize}discount`] = match ? parseFloat(match[0]) : 0;
          }
      });

      const experimentGroupV1 = window.igData?.user?.getTestGroup('280ab1a1-64cc-4f0c-9971-0032c9c89256');
      
      const packsToShow = [3, 6, 9];
      if (experimentGroupV1?.name.includes('C:')) {
        this.overWriteDiscount(3, 33.3333, firstVariant);
        this.overWriteDiscount(6, 38.8888, firstVariant);
        this.overWriteDiscount(9, 40, firstVariant);
      } else if (experimentGroupV1?.name.includes('V1')) {
          this.overWriteDiscount(3, 20, firstVariant);
          this.overWriteDiscount(6, 25, firstVariant);
          this.overWriteDiscount(9, 30, firstVariant);
      } else if(experimentGroupV1?.name.includes('V2')) {
          this.overWriteDiscount(3, 33.3333, firstVariant);
          this.overWriteDiscount(6, 38.8888, firstVariant);
          this.overWriteDiscount(9, 40, firstVariant);
      }

      packsToShow.forEach(packSize => {
          const pack = document.querySelector(`label[for="pack-${packSize}"].pack-size`);
          if (pack) pack.classList.remove('hidden');
      });
  }

  overWriteDiscount = (packSize, discount, firstVariant) => {
      const packsInput = document.querySelector(`#pack-${packSize}`);
      if (packsInput) packsInput.setAttribute('discount', discount);

      const labels = document.querySelector(`label[for="pack-${packSize}"].pack-size`);
      if (!labels) return;

      const savingsLabel = labels.querySelector('.savings');
      const priceFinal = labels.querySelector(".price-final");
      const priceDiscount = labels.querySelector(".price-discount");

      const priceTotal = window.igData.price.getPriceByVariantId(firstVariant) * packSize;
      const priceTotalDiscount = priceTotal - (priceTotal * (discount / 100));
      const save = priceTotal - priceTotalDiscount;

      if (packsInput) packsInput.setAttribute('pack_og', priceTotal.toFixed(2));
      if (packsInput) packsInput.setAttribute('pack_price', priceTotalDiscount.toFixed(2));

      if (savingsLabel) savingsLabel.innerHTML = ` ${window.theme.save_text} $${save.toFixed(2)} `;
      if (priceFinal) priceFinal.innerHTML = `$${priceTotalDiscount.toFixed(2)}`;
      if (priceDiscount) priceDiscount.innerHTML = `$${priceTotal.toFixed(2)}`;
  }



  updateIntelligencePrices() {
    if (window.igData && window.igData.price) {
      document.querySelectorAll(".variant__size").forEach((item) => {
        const intelligencePrice = window.igData.price.getPriceByVariantId(
          item.id
        );
        if (intelligencePrice) {
          item.setAttribute("price", intelligencePrice+'00');
        }
      });
    }
  }
  cleanUrlOnePack() {
    // for for="pack-1"
    const onePack = document.querySelector('label[for="pack-1"].pack-size');
    // on click remove the url query params 
    onePack.addEventListener('click', () => {
      const urlParams = new URLSearchParams(window.location.search);
      const paramValue = urlParams.get('bundle');
      if (paramValue) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    });
  }
  setColorByURL() {
    this.cleanUrlOnePack();
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get("bundle");
    const setParam = urlParams.get("color");
    if (paramValue) {
      this.packSizes.forEach((ps) => {
        console.log(`${paramValue} - ${ps.id}`);
        if (ps.id == paramValue) {
          ps.click();
        }
      });
    }
    console.log("setparam " + setParam);
    if (setParam != null) {
      console.log("color bundle clicked");
      this.querySelector(`#${setParam}`).click();
    }
    console.log(paramValue);
  }

  connectedCallback() {
    console.log(window.bundleVariants);
    let sizes = this.querySelectorAll(".size-variants__wrapper input");
    let unitSizes = document.querySelectorAll(
      'variant-radios fieldset[data-option-name="Size"] input'
    );
    let colorSets = this.querySelectorAll(".color-set__wrapper input");
    this.atcBtn.addEventListener("click", () => {
      this.multipleAddToCart();
    });
    sizes.forEach((size) => {
      size.addEventListener("click", () => {
        this.pickSize();
      });
    });
    unitSizes.forEach((size) => {
      size.addEventListener("click", () => {
        //this.querySelector(`.size-variants__wrapper input[value="${size.value}"]`).checked = true;
        //this.querySelector('.pack-size__wrapper input[value="1"]').click();
      });
    });
    colorSets.forEach((colorSet) => {
      colorSet.addEventListener("click", () => {
        this.pickSize();
      });
    });
    this.packSizes.forEach((pk) => {
      pk.addEventListener("click", () => {
        this.changePackSize();
      });
    });
    this.changePackSize();
    this.pickSize();
  }

  disconnectedCallback() { }

  static get observedAttributes() {
    return [
      /* array of attribute names to monitor for changes */
    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // called when one of attributes listed above is modified
  }

  pickSize() {
    this.querySelector(".addtocart-error").style.display = "none";
    this.available = true;
    this.totalItems = 0;
    this.variants_IDs = [];
    let colorHeader = this.querySelector(".color_picker-header p span");
    let color = document.querySelector(".color-set__wrapper input:checked");
    console.log(color);
    let packSize = this.querySelector(".pack-size__wrapper input:checked");
    let opts = document.querySelectorAll(
      ".color-set__wrapper input:checked + label .variant__size"
    );
    let checkedOpt = document.querySelector(
      ".size-variants__wrapper input:checked"
    );
    console.info(checkedOpt);
    /*let notCheckedOpt = document.querySelectorAll('.size-variants__wrapper input');
      if(checkedOpt.disabled) {disc

      }
      notCheckedOpt.forEach((ntc, index) => {
          if(ntc.checked) {
              if(ntc.disabled) {
                  if(notCheckedOpt[index+1].disabled == false) {
                      notCheckedOpt[index+1].click();
                  }
              }
          }
      });*/
    if (checkedOpt) {
      let itemsAdded = true;
      let dummyWrapper = this.querySelector("#dummyPack");
      opts.forEach((opt) => {
        if (checkedOpt.value.toLowerCase() == opt.getAttribute("size")) {
          //console.log(color.value);
          //console.log(opt.getAttribute("item-qty"));
          this.variants_IDs.push(opt);
          console.log("opt: ", opt);

          this.va;
          this.totalItems =
            this.totalItems + parseInt(opt.getAttribute("item-qty"));
          if (opt.getAttribute("quantity") < 5) {
            itemsAdded = false;
            this.available = false;
          }
        }
      });
      dummyWrapper.value = color.getAttribute("dummy");
    
      
      let grandParent = color.getAttribute("grand-parent-id");
      if ( grandParent) {
        this._grandparent_id = color.getAttribute("grand-parent-id");
        this._grand_parent_title = color.getAttribute("grand-parent-title");
      }
      colorHeader.innerHTML = "";
      if (itemsAdded) {
        console.log(this.totalItems);
        this.atcBtn.classList.remove("disabled-error");
        //this.atcBtn.classList.remove('disabled');
        this.atcBtn.innerHTML = window.theme.add_to_cart;
      } else {
        console.log("here");
        this.atcBtn.classList.add("disabled-error");
        this.atcBtn.innerHTML = window.theme.add_to_cart;
      }
      let activeColors = null;
      if (color && color.nextElementSibling) {
        activeColors =
          color.nextElementSibling.querySelectorAll(".color-set__sizes");
      }
      console.log(activeColors);
      if (activeColors) {
        activeColors.forEach((ac) => {
          if (colorHeader.innerHTML != "") {
            colorHeader.innerHTML += " / ";
          }
          colorHeader.innerHTML += ac.getAttribute("color").replace("-", " ");
        });
        this.querySelector(".size-variants__wrapper").classList.remove(
          "disabled"
        );
        this.querySelector(".msg__error").classList.add("hidden");
        this.changePrice();
      } else {
        colorHeader.innerHTML = "-";
        this.querySelector(".size-variants__wrapper").classList.add("disabled");
        this.querySelector(".msg__error").classList.remove("hidden");
        this.variants_IDs = [];
        this.atcBtn.classList.add("disabled");
        this.atcBtn.innerHTML = "sold out";
        this.changePrice();
      }
      this.outOfStock();
    } else {
      this.atcBtn.classList.remove("disabled");
      let activeColors = null;
      if (color && color.nextElementSibling) {
        activeColors =
          color.nextElementSibling.querySelectorAll(".color-set__sizes");
      }
      colorHeader.innerHTML = "";
      if (activeColors) {
        activeColors.forEach((ac) => {
          if (colorHeader.innerHTML != "") {
            colorHeader.innerHTML += " / ";
          }
          colorHeader.innerHTML += ac.getAttribute("color").replace("-", " ");
        });
        this.querySelector(".size-variants__wrapper").classList.remove(
          "disabled"
        );
        this.querySelector(".msg__error").classList.add("hidden");
        this.changePrice();
      }
      this.atcBtn.innerHTML = window.theme.add_to_cart;
      this.outOfStock();
    }
    if (this.querySelector(".size-variants__wrapper input:checked")) {
      if (
        this.querySelector(".size-variants__wrapper input:checked").disabled
      ) {
        this.atcBtn.innerHTML = "Sold out";
        this.atcBtn.classList.add("disabled");
      } else {
        this.atcBtn.innerHTML = window.theme.add_to_cart ? window.theme.add_to_cart: "Add to Cart"; 
        this.atcBtn.classList.remove("disabled");
      }
    }
    window.PacksCore.setUrlByColor(color.getAttribute('id'), packSize.value);
    this.createSliderImage();
    this.changePrice();
  }

  async multipleAddToCart(itemProps) {
    if (
      !this.atcBtn.classList.contains("disabled-error") &&
      this.querySelector(".msg__error").classList.contains("hidden")
    ) {
      this.atcBtn.classList.add("loading");
      let packSize = this.querySelector(".pack-size__wrapper input:checked");
      let dummyProps = "";
      let packDiscount = 0;
      let packPrice = 0;
      let productSize = this.querySelector(
        ".size-variants__wrapper input:checked"
      ).value;
      this.variants_IDs.forEach((VId) => {
        if (dummyProps != "") {
          dummyProps += " / " + VId.getAttribute("color");
        } else {
          dummyProps += VId.getAttribute("color");
        }
        //console.log('intelli price',window.igData.price.getPriceByVariantId(VId.id));
        let subtotal =
          parseInt(VId.getAttribute("price")) *
          parseInt(VId.getAttribute("item-qty"));
        if (window.igData && parseInt(window.igData.price.getPriceByVariantId(VId.id))) {
          subtotal =
            parseInt(window.igData.price.getPriceByVariantId(VId.id)) *
            parseInt(VId.getAttribute("item-qty"));
        }

        packDiscount += subtotal;
      });
      let originalPrice = packDiscount;
      packPrice = packDiscount;
      packDiscount =
        packDiscount * parseFloat(packSize.getAttribute("discount"));
      packDiscount = packDiscount / 100;
      packPrice = packPrice - packDiscount;
      if (this.available) {
        let bundleIndex = Date.now();
        let all_items = this.sidecart.querySelectorAll(".sidecart__item");
        all_items.forEach((item) => {
          if (item.getAttribute("bundleindex")) {
            bundleIndex++;
          }
        });
        console.log(bundleIndex);
        let updates = {
          items: [],
        };
        let dummyPack = {
          id: this.querySelector("#dummyPack").value,
          quantity: 1,
          properties: {
            dummyPack: true,
            bundle_index: bundleIndex,
            innerItems: dummyProps,
            ogp: `${originalPrice} - ${packPrice}`,
            packSize: packSize.value,
            originalprice: `${originalPrice}`,
            packPrice: packPrice,
            prodSize: productSize,
          },
        };
        this.variants_IDs.forEach((variantID) => {
          let thisDiscount = packSize.getAttribute("discount");
          let thisID = variantID.getAttribute("id");
          let thisQty = variantID.getAttribute("item-qty");
          const originalItemPrice = (variantID.getAttribute("price") / 100) ;
          const discountedItemPrice = originalItemPrice - (originalItemPrice * thisDiscount / 100);
         // const intelligemsDiscount = (window.igData.price.getDiscountByVariantId(thisID) / 100);
          const packOriginalPrice = (parseInt(packSize.value) * this.unitOriginalPrice) / 100;
          //const igPlusDiscount = intelligemsDiscount ? this.calculateExtraDiscount(packOriginalPrice, packPrice, parseFloat(thisDiscount)): null;
          let obj = {
            id: thisID,
            quantity: parseInt(thisQty),
            properties: {
              _bundle_index: bundleIndex,
              _teepack: true,
              _discount: thisDiscount,
              _parent_id: dummyPack.id,
              _parent_name: this._grand_parent_title,
              _original_price: originalPrice,
              _total_price: packPrice,
             // _ig_data_v: igPlusDiscount,
              'Original price': `${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(originalItemPrice)}`,
              'Discounted price': `${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(discountedItemPrice)}`
            },
          };
          if (this._grandparent_id != null) {
            obj.properties._grandparent_id = this._grandparent_id;
          }
          updates.items.push(obj);
        });
        //updates.items.push(dummyPack);
        console.log(updates);
        const properties = {
          ...fetchConfig("javascript"),
          body: JSON.stringify(updates),
        };
        try {
          const response = await fetch("/cart/add.js", properties);
          const data = await response.json();

          // get the cart data and then render on the side cart
          this.atcBtn.classList.remove("loading");
          
          if (response.ok) {
            this.sidecart.getCart();
            this.sidecart.openCart();
          } else {
            // Send GTM event for HTTP errors
            if (window.AddResponseHandler) {
              window.AddResponseHandler.handleCartAddError(updates, response, data, null, 'bundle_add');
            }
          }
        } catch (err) {
          console.error(err);
          
          // Send GTM event for network/fetch errors
          if (window.AddResponseHandler) {
            window.AddResponseHandler.handleCartAddError(updates, null, null, err, 'bundle_add');
          }
        }
      }
    } else {
      this.querySelector(".addtocart-error").style.display = "block";
    }
  }

  calculateExtraDiscount(originalPrice, desiredDiscountedPrice, initialDiscountPercentage) {
      const totalDiscountNeeded = ((originalPrice - desiredDiscountedPrice) / originalPrice) * 100;
      const extraDiscountNeeded = totalDiscountNeeded - initialDiscountPercentage;
      return extraDiscountNeeded.toFixed(4);
  }
  pickFit(fit) {
    if (fit) {
      this.changeIcon(fit);
    }
    let items = document.querySelectorAll(".product-fit__choice");
    let packSize = this.querySelector(".pack-size__list input:checked");
    let wrappers = this.querySelectorAll(".color-set__wrapper");
    let colorHeader = this.querySelector(".color_picker-header p span");
    colorHeader.innerHTML = "-";
    this.querySelector(".size-variants__wrapper").classList.add("disabled");
    this.querySelector(".msg__error").classList.remove("hidden");
    //this.atcBtn.classList.add('disabled');
    if (packSize.value != 1) {
      //packSize.nextElementSibling.querySelector('.price').innerHTML = '-';
    }
    this.variants_IDs = [];
    //this.atcBtn.classList.add('disabled');
    this.atcBtn.innerHTML = window.theme.add_to_cart ? window.theme.add_to_cart: "Add to Cart"; 
    wrappers.forEach((wrapper) => {
      wrapper.classList.add("hidden");
    });
    wrappers.forEach((wrapper) => {
      items.forEach((item) => {
        if (item.classList.contains("fit-active")) {
          if (wrapper.getAttribute("fit") == item.getAttribute("data-fit")) {
            if (wrapper.getAttribute("pack-size") == packSize.value) {
              wrapper.classList.remove("hidden");
              wrapper.querySelector("input").checked = true;
              this.pickSize();
            }
          }
        }
      });
    });
    this.createSliderImage();
    this.outOfStock();
    fontResize();
    this.changePrice();
  }

  changePrice() {
    console.log("changePrice called");
    let atc = this.querySelector(".multiple-add-to-cart");
    let packSize = this.querySelector(".pack-size__wrapper input:checked");
    let packDiscount = 0;
    let unitPrice = document.querySelector(".unit__price");
    let packPrice = 0;
    let titlePrice = document.querySelector(".pack-title__price");
    let packEach = document.querySelector(`.convert_each span[data-unit="${packSize.value}"]`);
    let ogPrice = 0;
    console.log(this.variants_IDs);
    
    if (this.variants_IDs.length != 0) {
      
      this.variants_IDs.forEach((VId) => {
        console.log("VId", VId);
        const itemPrice = VId.getAttribute("price") / 100;
        const itemQty = VId.getAttribute("item-qty");
       
        let subtotal =
          parseInt(itemPrice  ) *
          parseInt(itemQty);
        packDiscount += subtotal;
      });
      ogPrice = packDiscount;
      packPrice = packDiscount;
      packDiscount =
        packDiscount * parseFloat(packSize.getAttribute("discount"));
      packDiscount = packDiscount / 100;
      packPrice = packPrice - packDiscount;
    }
    let priceItem = packSize.nextElementSibling;
    console.log('priceItem', priceItem);
    priceItem = priceItem.querySelector(".price");
    if (packSize.value != 1) {
      if (packPrice == 0) {
        //priceItem.innerHTML = `-`;
        atc.innerHTML = window.theme.add_to_cart;
      } else {
        priceItem.innerHTML = `${window.theme.cart_currency_symbol}${Shopify.formatMoneyAmmount(packPrice)} <small>${window.theme.cart_currency_symbol}${Shopify.formatMoneyAmmount(ogPrice)} </small>`;
        //packEach.innerHTML = Math.ceil(Shopify.formatMoneyAmmount(packPrice) / parseInt(packSize.value));
        //atc.innerHTML = 'add to cart';
      }
      unitPrice.classList.add("hidden");
      titlePrice.classList.remove("hidden");
    } else {
      unitPrice.classList.remove("hidden");
      titlePrice.classList.add("hidden");
    }
    const clonedPriceItem = priceItem.cloneNode(true);
    const priceFinal = clonedPriceItem.querySelector('.price-final');
    const priceDiscount = clonedPriceItem.querySelector('.price-discount');

    if (priceFinal && priceDiscount) {
        priceFinal.innerHTML = priceFinal.innerHTML + ` ${window.theme.shop_currency}`;
        priceDiscount.innerHTML = priceDiscount.innerHTML + ` ${window.theme.shop_currency}`;
    } else {
      clonedPriceItem.innerHTML = `${window.theme.cart_currency_symbol} ${packPrice.toFixed(2)} ${window.theme.shop_currency} <small>${window.theme.cart_currency_symbol}${ogPrice} ${window.theme.shop_currency}</small>`;
    }

    titlePrice.innerHTML = clonedPriceItem.innerHTML;
    fontResize();
  }

  changePackSize() {
    let wrapper = document.querySelector(".product-pack__content");
    let unitEls = {
      vr: document.querySelector("variant-radios"),
      vrSW: document.getElementById("variant-radios-single-wrapper"),
      fcp: document.querySelector("fit-color-picker .product-color_picker"),
      pf: document.querySelector(".product-buy-buttons"),
      vrsg: document.querySelector(".variant-radios__size-guide"),
    };
    let checkedOpt = this.querySelector(".pack-size__wrapper input:checked");
    console.log(checkedOpt.value); 
    if (checkedOpt.value == 1) {
      wrapper.classList.add("hidden");
      unitEls.vr.classList.remove("hidden");
      unitEls.vrSW.classList.remove("hidden");
      unitEls.fcp.classList.remove("hidden");
      unitEls.pf.classList.remove("hidden");
      unitEls.vrsg.classList.remove("hidden");
      let unitChecked = document.querySelector(
        `variant-radios fieldset[data-option-name="Size"] input:checked`
      );
      if (unitChecked) {
        unitChecked.checked = false;
        unitChecked.click();
      } else {
        let packChecked = this.querySelector(
          ".size-variants__wrapper input:checked"
        );
        if (packChecked) {
          console.log(packChecked.value);
          document
            .querySelector(
              `variant-radios fieldset[data-option-name="Size"] input[value="${packChecked.value}"]`
            )
            .click();
        }
      }
    } else {
      let unitSize = document.querySelector(
        'variant-radios fieldset[data-option-name="Size"] input:checked'
      );
      let sizes = this.querySelectorAll(".size-variants__wrapper input");
      if (unitSize) {
        unitSize.checked = false;
        sizes.forEach((size) => {
          if (size.value == unitSize.value) {
            size.checked = true;
          }
        });
      }
      wrapper.classList.remove("hidden");
      unitEls.vr.classList.add("hidden");
      unitEls.vrSW.classList.add("hidden");
      unitEls.fcp.classList.add("hidden");
      unitEls.pf.classList.add("hidden");
      unitEls.vrsg.classList.add("hidden");
    }
    this.pickFit();
  }

  outOfStock() {
    let pack = this.querySelector(".color-set__wrapper:not(.hidden)");
    if (pack) {
      let packItmes = pack.querySelector("input:checked");
      let sizes = this.querySelectorAll(".size-variants__wrapper input");
      let disable = false;
      packItmes =
        packItmes.nextElementSibling.querySelectorAll(".color-set__sizes");
      sizes.forEach((size) => {
        size.classList.remove("disabled");
        size.disabled = false;
        packItmes.forEach((item) => {
          let itemSizes = item.querySelectorAll(".variant__size");
          itemSizes.forEach((itemSize) => {
            if (itemSize.getAttribute("size") == size.value.toLowerCase()) {
              if (itemSize.getAttribute("quantity") < 5) {
                size.classList.add("disabled");
                size.disabled = true;
              }
            }
          });
        });
      }); /*
          if(this.querySelector('.size-variants__wrapper input:checked').disabled) {
            let endloop = false;
            sizes.forEach(size => {
              if(!size.disabled) {
                if(endloop == false) {
                  size.click();
                  endloop = true;
                }
              }
            })
          }*/
    }
  }

  createSliderImage() {
    let bundleImg = document.querySelector(
      '.product-images-container .swiper-slide[data-swiper-slide-index="0"] .img_slider'
    );
    let bundleImgDup = document.querySelector(
      '.product-images-container .swiper-slide-duplicate[data-swiper-slide-index="0"] img'
    );
    let bundleDot = document.querySelectorAll(
      ".product-images-container .swiper-pagination .swiper-pagination-bullet img"
    );
    let color = document.querySelector(
      ".color-set__wrapper:not(.hidden) input:checked"
    );
    let modalImg = document.querySelector(
      '.product-images_zoomup-container .swiper-wrapper .swiper-slide[data-swiper-slide-index="0"] img'
    );
    let modalImgDup = document.querySelector(
      '.product-images_zoomup-container .swiper-wrapper .swiper-slide-duplicate[data-swiper-slide-index="0"] img'
    );
    let packSize = this.querySelector(".pack-size__list input:checked");
    if (packSize.value != 1) {
      if (color) {
        console.log("bundle");
        bundleImg.src = color.getAttribute("img");
        bundleImgDup.src = color.getAttribute("img");
        modalImg.src = color.getAttribute("img");
        modalImgDup.src = color.getAttribute("img");
        if (window.innerWidth >= 750) {
          bundleDot[0].src = color.getAttribute("img");
        }
        let bullet = document.querySelector(
          ".swiper-pagination .swiper-pagination-bullet"
        );
        bullet.click();
      }
    } else {
      console.log("original");
      bundleImg.src = bundleImg.getAttribute("original");
      bundleImgDup.src = bundleImg.getAttribute("original");
      modalImg.src = bundleImg.getAttribute("original");
      modalImgDup.src = bundleImg.getAttribute("original");
      if (window.innerWidth >= 750) {
        bundleDot[0].src = bundleImg.getAttribute("original");
      }
    }
  }
}

customElements.define("product-pack", ProductPack);
